/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RebookingDto } from '../../models/rebooking-dto';
import { RebookingForm } from '../../models/rebooking-form';

export interface RebookOpenPositions$Params {
      body: RebookingForm
}

export function rebookOpenPositions(http: HttpClient, rootUrl: string, params: RebookOpenPositions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RebookingDto>>> {
  const rb = new RequestBuilder(rootUrl, rebookOpenPositions.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RebookingDto>>;
    })
  );
}

rebookOpenPositions.PATH = '/rebookings';
